import { callsvg, travel, whatsapp } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Inquiry } from '@apis'
import UserProfile from '@components/userprofile'
import Status from '@components/status'
import { toast } from 'react-toastify'

const TravelInquiry = ({ user }: { user?: any }) => {
  const {
    items: Inquiries = [],
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.inquiry)
  const [page, setPage] = React.useState(1)
  const fetchInquiries = async () => {
    await Inquiry.list({
      state: 'inquiry',
      params: {
        ...(user?.id && { createdBy: user?.id }),
        limit: 20,
        page,
      },
    })
  }
  const columns = [
    {
      title: 'User Detail',
      key: 'userDetail',
      render: (item) => <UserProfile item={item?.user} />,
    },
    {
      title: 'Departure City',
      key: 'departureCity',
      render: (item) => item.departure.name,
    },
    {
      title: 'Destination City',
      key: 'destinationCity',
      render: (item) => item.destination.name,
    },
    {
      title: 'Number of Passengers',
      key: 'noOfPassengers',
      render: (item) => item.noOfPassenger,
    },
    {
      title: 'Vehicle Type',
      key: 'vehicleType',
      render: (item) => item.vehicleType,
    },
    { title: 'Date of Journey', key: 'date', render: (item) => item.date },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Status
          item={item}
          statuses={['Pending', 'Confirmed', 'Cancelled']}
          onStatusChange={async (status) => {
            await Inquiry.updateStatus({
              id: item?.id,
              data: {
                status: status === 'Confirmed' ? 'Approved' : 'Rejected',
              },
            })
            toast.success('Status updated successfully.')
          }}
        />
      ),
    },
  ]

  useEffect(() => {
    // if (!user?.id) return
    fetchInquiries().then(() => {})
  }, [page, user])

  const handleWhatsAppClick = (item: any) => {
    if (!item?.user?.phoneNo) return
    const phone = item.user.phoneNo.replace(/\D/g, '') // remove any non-digit characters
    const message = encodeURIComponent('Hello! Regarding your travel inquiry.')
    const url = `https://wa.me/${phone}?text=${message}`
    window.open(url, '_blank') // open WhatsApp in a new tab
  }

  const handleCallClick = (item: any) => {
    if (!item?.user?.phoneNo) return
    window.location.href = `tel:${item.user.phoneNo}` // initiate call
  }
  return (
    <Table
      text="Travel Inquiry"
      icon={travel}
      columns={columns}
      data={Inquiries}
      totalPages={totalPages}
      loading={loading}
      totalItems={totalItems}
      pageControlled={page}
      onPageChange={setPage}
      actions={[
        {
          icon: callsvg,
          key: 'call',
          onClick: (item) => {
            handleCallClick(item)
          },
        },
        {
          icon: whatsapp,
          key: 'whatsapp',
          onClick: (item) => handleWhatsAppClick(item),
        },
      ]}
    />
  )
}

export default TravelInquiry
